import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup, Button } from 'react-bootstrap'
import { momentHelper } from '../helpers'
import SelectDate from 'component/element/SelectDate'
import Select from 'react-select'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import PODocStore from 'stores/PODocStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwesome from 'react-fontawesome'
import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'
import Moment from 'moment'
import '../report.css'
// import { connect } from 'react-redux';
const localStorageKey = 'kkc.report-po'
class ReportPOReceivedProduct extends Component {
  constructor(props) {
    super(props)
    const WHOLE_YEAR = momentHelper.getMonth() //'00'

    this.state = {
      loading:false,
      activePage:1,
      shopId:'',
      shopList:[],
      month:WHOLE_YEAR,
      year:momentHelper.getYear(),
      data:[],
      isRange:false,
      day:momentHelper.getDay(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear(),
      sort: JSON.parse(localStorage.getItem(localStorageKey)) || {sortStatus:'',sortStatus2:''}
    }
    this.refTableId = 'ReportPOReceivedProduct-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year,this.state.month,this.state.day,this.state.shopId)
      // this.loadSupplierList()
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    if (all_day) {
      if (all_day<this.state.day) {
        var defaultDay = '00'
      } else {
        var defaultDay = this.state.day
      }
    } else {
      var defaultDay = '00'
    }
    return defaultDay
}

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total = total + (item[field]==''||item[field]==null||item[field]==undefined||isNaN(item[field])?0:parseFloat(item[field]))
    }) 
    return total
  }

  // loadSupplierList() {
  //   let {shopList} = this.state
  //   shopList.push({label:'-- เลือกร้าน --',value:''},{label:'ร้านทั้งหมด',value:'all'})
  //   PODocStore.loadSupplierList('','',(result)=>{
  //       result.data.forEach((item,index)=>{
  //           shopList.push({
  //               label:item.name,
  //               value:item.shop_id
  //           })
  //       })
  //       this.setState({shopList:shopList})
  //   })
  // }

  loadData(year='',month='',day='',shopId='',isSelect=false) {
    let {sort,shopList} = this.state
    this.setState({loading:true,isRange:false,dayRange:momentHelper.getDay(),monthRange:month,yearRange:year})
    ReportStore.loadReportPurchaseorderRecordProduct(year,month,day,shopId,this.props.type,(result)=>{
      if (!isSelect) {
        shopList = [{label:'-- เลือกร้าน --',value:''},{label:'ร้านทั้งหมด',value:'all'}]
        result.supplierlist.forEach((item,index)=>{
          shopList.push({
              label:item.name,
              value:item.shop_id
          })
        })
      }  

      let data = result.data
      if (sort.sortStatus===''&&sort.sortStatus2==='') {  
        data = result.data
      } else {
        if (sort.sortStatus!=='') {
          if (sort.sortStatus===''||sort.sortStatus==='desc') {
            data.sort(function(a, b) {
              if(a.record_date < b.record_date) return -1;
              if(a.record_date > b.record_date) return 1;
              return 0;
            })
            data.reverse(function(a, b) {
              if(a.record_date < b.record_date) return -1;
              if(a.record_date > b.record_date) return 1;
              return 0;
            })
          } else if (sort.sortStatus==='asc') {
            data.sort(function(a, b) {
              if(a.record_date < b.record_date) return -1;
              if(a.record_date > b.record_date) return 1;
              return 0;
            })
          }
        } else if (sort.sortStatus2!=='') {
          if (sort.sortStatus2===''||sort.sortStatus2==='desc') {
            data.reverse(function(a, b) {
              if(a.purchase_order_no < b.purchase_order_no) return -1;
              if(a.purchase_order_no > b.purchase_order_no) return 1;
              return 0;
            })
          } else if (sort.sortStatus2==='asc') {
            data.sort(function(a, b) {
              if(a.purchase_order_no < b.purchase_order_no) return -1;
              if(a.purchase_order_no > b.purchase_order_no) return 1;
              return 0;
            })
          }
        }
      }
      this.setState({loading:false,data:data,shopList:shopList})
      if (!isSelect)
        this.setState({shopId:''})
    })
  }

  loadDataRange(start='',end='',shopId='',isSelect=false) {
    let {shopList} = this.state
    ReportStore.loadReportPurchaseorderRecordProductRange(start,end,shopId,this.props.type,(result)=>{
      if (!isSelect) {
        shopList = [{label:'-- เลือกร้าน --',value:''},{label:'ร้านทั้งหมด',value:'all'}]
        result.supplierlist.forEach((item,index)=>{
          shopList.push({
              label:item.name,
              value:item.shop_id
          })
        })
      }
      this.setState({loading:false,data:result.data,shopList:shopList})
      if (!isSelect)
        this.setState({shopId:''})
    })
  }

  renderBody() {
    let {data,shopId} = this.state
    if (data.length==0) {
      return(<tr><td colSpan={13}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{item.record_date}</td>
              <td className='text-center'>{item.purchase_order_no}</td>
              <td className='text-left'>{item.detail}</td>
              <td className='text-center'>{item.quantity}</td>
              <td className='text-right'>{this.getNumberFormat(item.price_per_unit)}</td>
              <td className='text-right'>{this.getNumberFormat(item.amount_before_discount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.vat)}</td>
              <td className='text-right'>{this.getNumberFormat(item.discount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.vat_after_discount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
              <td className='text-center'>{item.recieved_by}</td>
              <td className='text-left'>{item.remark}</td>
            </tr>
        ) 
      )  
    }
  }

  getDate() {
    let {day,year,month,isRange,dayRange,monthRange,yearRange} = this.state
    if (isRange) {
      let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+year
      let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+yearRange
      return 'ประจำวันที่ '+start+' - '+end
    } else {
      let text = 'ประจำวันที่ '
      text += day+' '+momentHelper.getMonthText(month)+' '+year
      if (year==='0'||year==='00'||year===0) {
        text = 'ทั้งหมด'
      } else if (month==='0'||month==='00'||month===0) {
        text = 'ประจำปี '+year
      } else if (day==='0'||day==='00'||day===0) {
        text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
      }
      return text
    }  
  }

  renderTable() {
    let {type} = this.props
    let {sort} = this.state
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid' style={{minWidth:'1400px'}}>
          <thead>
            <tr>
              <th style={{display:'none'}} className='text-center' colSpan={13}>{(this.props.type=='received'?'รายงานรับอะไหล่จากใบสั่งซื้อ':this.props.type=='exportwork'?'รายงานเบิกอะไหล่จากใบสั่งซื้อ':this.props.type=='return'?'รายงานคืนอะไหล่จากใบสั่งซื้อ':'รายงานรับอะไหล่จากใบสั่งซื้อ')} {this.getDate()}</th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'20px'}}>ลำดับ</th>
              <th onClick={this.onSortClick.bind(this,'record_date')} className='text-center' style={{width:'90px'}}>วันที่&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus===''?'sort':sort.sortStatus==='asc'?'sort-asc':sort.sortStatus==='desc'?'sort-desc':'sort')} /></th>
              <th onClick={this.onSortClick.bind(this,'purchase_order_no')} className='text-center' style={{width:'100px'}}>เลขใบสั่งซื้อ&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus2===''?'sort':sort.sortStatus2==='asc'?'sort-asc':sort.sortStatus2==='desc'?'sort-desc':'sort')} /></th>
              <th className='text-center' style={{width:'170px'}}>รายการ</th>
              <th className='text-center' style={{width:'50px'}}>จำนวน</th>
              <th className='text-center' style={{width:'80px'}}>ราคา<br />หน่วยละ</th>
              <th className='text-center' style={{width:'80px'}}>จำนวนเงิน</th>
              <th className='text-center' style={{width:'80px'}}>ภาษีก่อน</th>
              <th className='text-center' style={{width:'80px'}}>ส่วนลด</th>
              <th className='text-center' style={{width:'80px'}}>ภาษีหลัง</th>
              <th className='text-center' style={{width:'80px'}}>รวมทั้งสิ้น</th>
              <th className='text-center' style={{width:'90px'}}>{type=='received'?'ผู้รับ':type=='exportwork'?'ผู้เบิก':type=='return'?'ผู้คืน':'ผู้รับ'}</th>
              <th className='text-center' style={{width:'120px'}}>หมายเหตุ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderBody()}
          </tbody>
          <tfoot>
            <tr>
                <th colSpan={6} className='text-right'></th>
                <th className='text-right'>{this.getNumberFormat(this.getSummary('amount_before_discount'))}</th>
                <th className='text-right'>{this.getNumberFormat(this.getSummary('vat'))}</th>
                <th className='text-right'>{this.getNumberFormat(this.getSummary('discount'))}</th>
                <th className='text-right'>{this.getNumberFormat(this.getSummary('vat_after_discount'))}</th>
                <th className='text-right'>{this.getNumberFormat(this.getSummary('amount'))}</th>
                <th colSpan={2} className='text-right'></th>
            </tr>
          </tfoot>    
        </table>
      </div>
    )
  }

  onSortClick(key,e) {
    let {data,sort} = this.state
    if (data!==undefined&&data.length>1) {
      if (key==='record_date') { 
        if (sort.sortStatus===''||sort.sortStatus==='desc') {
          sort.sortStatus = 'asc'
          data.sort(function(a, b) {
            if(a.record_date < b.record_date) return -1;
            if(a.record_date > b.record_date) return 1;
            return 0;
          })
        } else if (sort.sortStatus==='asc') {
          sort.sortStatus = 'desc'
          data.reverse(function(a, b) {
            if(a.record_date < b.record_date) return -1;
            if(a.record_date > b.record_date) return 1;
            return 0;
          })
        }
        sort.sortStatus2 = ''
      } else if (key==='purchase_order_no') { 
        if (sort.sortStatus2===''||sort.sortStatus2==='desc') {
          sort.sortStatus2 = 'asc'
          data.sort(function(a, b) {
            if(a.purchase_order_no < b.purchase_order_no) return -1;
            if(a.purchase_order_no > b.purchase_order_no) return 1;
            return 0;
          })
        } else if (sort.sortStatus2==='asc') {
          sort.sortStatus2 = 'desc'
          data.reverse(function(a, b) {
            if(a.purchase_order_no < b.purchase_order_no) return -1;
            if(a.purchase_order_no > b.purchase_order_no) return 1;
            return 0;
          })
        }
        sort.sortStatus = ''
      }
      let reportPoConfig = {sortStatus:sort.sortStatus,sortStatus2:sort.sortStatus2}
      localStorage.setItem(localStorageKey, JSON.stringify(reportPoConfig))
      this.setState({data:data,sort:sort})
    }  
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

  onDayChange(val){
    this.setState({
      day: val.value, isRange:false
    })
    this.loadData(this.state.year,this.state.month,val.value,this.state.shopId)
  }

  onMonthChange(val) {
    let date = this.state.year-543+'-'+val.value
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      month: val.value, isRange: false, day:_day
    })
    this.loadData(this.state.year,val.value,_day,this.state.shopId)
  }

  onYearChange(val) {
    let date = val.value-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      year: val.value, isRange: false, day:_day
    })
    this.loadData(val.value,this.state.month,_day,this.state.shopId)
  }

  onShopChange(val) {
    let {isRange,dayRange,monthRange,yearRange} = this.state
    this.setState({
      shopId: val.value, isRange: false
    })
    if (isRange) {
      let time = this.state.dayRange+'/'+this.state.monthRange+'/'+this.state.yearRange
      if (time!=''&&time!=undefined&&time!=null) {
        let _yearRange = yearRange
        let _monthRange = monthRange
        let _dayRange = dayRange
        let {day,month,year} = this.state
        let _day = _dayRange*1
        let _month = _monthRange*1
        let _year = _yearRange*1
        this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
        year = year - 543
        _year = _year - 543
        let start = day+'/'+(month=='00'?'1':month)+'/'+year
        let end = _day+'/'+_month+'/'+_year
        this.loadDataRange(start,end,val.value,true)
      }
    } else
      this.loadData(this.state.year,this.state.month,this.state.day,val.value,true)
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = this.props.type=='received'?'รายงานรับอะไหล่จากใบสั่งซื้อ.xlsx':this.props.type=='exportwork'?'รายงานเบิกอะไหล่จากใบสั่งซื้อ.xlsx':this.props.type=='return'?'รายงานคืนอะไหล่จากใบสั่งซื้อ.xlsx':'รายงานรับอะไหล่จากใบสั่งซื้อ.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    const {isRange} = this.state
    let url = ''
    let param = 'PrintReportPOReceivedProduct&year='+this.state.year+'&month='+this.state.month+'&day='+this.state.day+'&shopId='+this.state.shopId+'&type='+this.props.type+'&isRange=false'
    if (isRange) {
        let {day,month,year,dayRange,monthRange,yearRange} = this.state
        let start = day+'/'+(month=='00'?'1':month)+'/'+(year-543)
        let end = dayRange+'/'+monthRange+'/'+(yearRange-543)
        param = 'PrintReportPOReceivedProduct&start_date='+start+'&end_date='+end+'&shopId='+this.state.shopId+'&type='+this.props.type+'&isRange=true'
    }    

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadData(_year,_month,_day,this.state.shopId)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadDataRange(start,end,this.state.shopId)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadDataRange(start,end,this.state.shopId)
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
        <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.day=='00'?this.state.dayRange:this.state.day)+'/'+this.state.month+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={this.state.dayRange+'/'+this.state.monthRange+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
      </div>
    )
  }

  renderToolbar() {
    return(
      <Form inline>
        <FormGroup style={{verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>  
        <div style={{ width: '150px', display: 'inline-block', marginLeft:'5px' }}>
          <Select
            className='width-menu-outer'
            clearable={false}
            name="form-field-name"
            value={this.state.shopId}
            options={this.state.shopList}
            onChange={this.onShopChange.bind(this)}
          />
        </div>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadData(this.state.year,this.state.month,this.state.day,this.state.shopId)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  render() {
    const reportName = this.props.type=='received'?'รับอะไหล่จากใบสั่งซื้อ':this.props.type=='exportwork'?'เบิกอะไหล่จากใบสั่งซื้อ':this.props.type=='return'?'คืนอะไหล่จากใบสั่งซื้อ':'รับอะไหล่จากใบสั่งซื้อ'
    const reportDateText = momentHelper.getMonthText(this.state.month) + " " + this.state.year
    const title = reportName + ' ' + reportDateText
    const {loading} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu()}
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderDateRange()}
          {this.renderTable()}
          {/*this.renderPaging()*/}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
      </Box>
    )
  }
}

ReportPOReceivedProduct.defaultProps = {
  show: false,
  type: 'received'
}

export default ReportPOReceivedProduct;


// WEBPACK FOOTER //
// ./src/view/report/po/ReportPOReceivedProduct.js